<template>
    <section class="charts">
        <!-- <h3>Niveles de Rios
            <p>Load data with async</p>
        </h3> -->
        <vue-highcharts :options="options" :highcharts="Highcharts" ref="lineCharts"></vue-highcharts>
        <!-- <button @click="load">load</button>
        <button @click="update">update xAxis Categories</button>
        <button @click="remove">remove Series</button>
        <button @click="add">add Series</button> -->
    </section>
</template>
<script>
import VueHighcharts from "vue2-highcharts";
import Exporting from "highcharts/modules/exporting";
import Highcharts from "highcharts";
// import * as data from "../assets/data.js";

Exporting(Highcharts);
export default {
    name:'line-chart',
    props:{
        chart:{
            type:String,
            default:"spline"
        },
        title:{
            type:String,
            default:"Titulo Linea"
        },
        subtitle:{
            type:String,
            default:"Subtitulo Linea"
        },
        yaxistitle:{
            type:String,
            default:"Lectura Nivel"
        },
        categories:{
            type:Array,
            default:function(){
                return ["Lectura 1", "Lectura 2", "Lectura 3" ];
            }
        },
        serieInicial:{
            type:Array,
            default:function(){
                return {
                    name: 'Rio Lago',
                    marker: {
                        symbol: "circle"
                    },
                    data: [-7.0, 6.9, 3 ]
                };
            }
        },
        seriesAuxiliares:{
            type:Array,
            default:[]
        }
    },
    components: {
        VueHighcharts
    },
  data() {
    return {
        options: {
                chart: {
                    type: "spline"
                },
                title: {
                    text: this.title
                },
                subtitle: {
                    text: this.subtitle
                },
                xAxis: {
                    categories: this.categories
                },
                yAxis: {
                    title: {
                            text: this.yaxistitle
                        }
                },
                tooltip: {
                    crosshairs: true,
                    shared: true
                },
                credits: {
                    enabled: false
                },
                plotOptions: {
                    spline: {
                    marker: {
                        radius: 4,
                        lineColor: "#666666",
                        lineWidth: 1
                    }
                    }
                },
                series: [this.serieInicial]
            },
            Highcharts: Highcharts
    };
  },
  mounted() {
      console.log(this.categories);
      this.add();
  },
  methods: {
    load() {
      let lineCharts = this.$refs.lineCharts;
      //charts.showLoading('loading');

      // you also can use the delegateMethod()
      lineCharts.delegateMethod("showLoading", "Cargando...");
      setTimeout(() => {
        // lineCharts.addSeries(data.asyncData);
        lineCharts.hideLoading();
      }, 2000);
    },
    update() {
      let lineCharts = this.$refs.lineCharts;
      lineCharts
        .getChart()
        .xAxis[0].setCategories(this.categories);
    },
    remove() {
      this.$refs.lineCharts.removeSeries();
    },
    add() {
    //   console.log('llamando a añadir mas lecturas');
    //   aqui añadimos las lecturas recorriendo un auxiliar que tenga de los otros rios
    //   this.update();
        this.remove();
        // this.update();
        if(this.seriesAuxiliares.length>0){
            console.log(this.seriesAuxiliares)
            this.seriesAuxiliares.forEach(eld=>{
                this.$refs.lineCharts.addSeries(
                {
                    name:eld.name,
                    data: eld.data
                });
            })
            
        }

    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/charts/LineChart.vue